var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 40,
    viewBox: "0 0 33 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.0799 10.82L21.4199 1.16C20.6799 0.42 19.6599 0 18.5999 0H4.25989C2.05989 0 0.279888 1.8 0.279888 4L0.259888 36C0.259888 38.2 2.03989 40 4.23989 40H28.2599C30.4599 40 32.2599 38.2 32.2599 36V13.66C32.2599 12.6 31.8399 11.58 31.0799 10.82ZM21.8599 26H18.2599V32C18.2599 33.1 17.3599 34 16.2599 34C15.1599 34 14.2599 33.1 14.2599 32V26H10.6799C9.77989 26 9.33989 24.92 9.97989 24.3L15.5799 18.72C15.9799 18.34 16.5999 18.34 16.9999 18.72L22.5799 24.3C23.1799 24.92 22.7399 26 21.8599 26ZM20.2599 14C19.1599 14 18.2599 13.1 18.2599 12V3L29.2599 14H20.2599Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadFileIcon);
export default __webpack_public_path__ + "static/media/UploadFileIcon.f427cac840f9e6643253cb3b12dfd95a.svg";
export { ForwardRef as ReactComponent };